import { render } from "./MyCommission.vue?vue&type=template&id=5bddec9d&scoped=true"
import script from "./MyCommission.vue?vue&type=script&lang=js"
export * from "./MyCommission.vue?vue&type=script&lang=js"

import "./MyCommission.vue?vue&type=style&index=0&id=5bddec9d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bddec9d"]])

export default __exports__